export const GET_MODULE_NAMES = 'GET_MODULE_NAMES'
